import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectExpenseTypes,
  useCreateProjectExpenseType,
} from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { projectExpenseType } from "@planzone/dto";
import { events } from "@planzone/events";
import { useMessage } from "@components/useMessage";
import { ExpenseTypeIcon } from "./expenseTypeIcon";
import { ExpenseTypeCreation } from "./expenseTypeCreation";
import { Props } from "./types";
import styles from "./styles.scss";

function ExpenseTypeSelect({ formData, edit }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { projectExpenseTypes, retrieveProjectExpenseTypes } =
    useRetrieveProjectExpenseTypes();
  const { isRequestPending, createProjectExpenseType } =
    useCreateProjectExpenseType();

  React.useEffect(() => {
    retrieveProjectExpenseTypes();
  }, []);

  useMessage((message) => {
    if (
      message.type === events.createProjectExpenseTypeSucceeded &&
      message.data?.projectExpenseType
    ) {
      edit({ ...formData, expenseType: message.data.projectExpenseType });
    }
  });

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.opened]: isOpen,
            })}
          >
            {!!formData.expenseType.name ? (
              <ExpenseTypeIcon
                deletable
                expenseType={formData.expenseType}
                onClick={() =>
                  edit({ ...formData, expenseType: projectExpenseType })
                }
              />
            ) : (
              <div>
                {t("projectBudgetSynthesis.expenses.creation.expenseType")}
              </div>
            )}
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <form
            className={styles.list}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            {projectExpenseTypes.map((projectExpenseType) => (
              <ExpenseTypeIcon
                key={projectExpenseType.uuid}
                expenseType={projectExpenseType}
                onClick={() => {
                  edit({ ...formData, expenseType: projectExpenseType });
                  select(projectExpenseType);
                }}
              />
            ))}
            <ExpenseTypeCreation
              submit={(value) => {
                !isRequestPending &&
                  createProjectExpenseType({
                    planzone,
                    projectExpenseType: value,
                  });
                select(value);
              }}
            />
          </form>
        ),
      })}
    </SelectList>
  );
}

export { ExpenseTypeSelect };
